export default import.meta.env.VITE_CYPRESS_TESTS === "true";
